import { parse } from 'date-fns';
import { z } from 'zod';

export const queryParamsSchema = z.object({
  date: z.optional(
    z.string().transform((val): Date => parse(val, 'yyyyMMdd', new Date()))
  ),
  plan: z.optional(
    z.enum(['std', 'plus', 'maxi']).transform(val => {
      switch (val) {
        case 'std':
          return 'standard';
        default:
          return val;
      }
    })
  ),
  dob: z.optional(
    z.string().transform((val): Date => parse(val, 'yyyyMMdd', new Date()))
  ),
  rate: z.optional(z.string().transform(val => +val)),
  sal: z.optional(z.string().transform(val => +val)),
  fund: z.optional(z.string().transform(val => +val)),
  trans: z.optional(z.string().transform(val => +val)),
  transint: z.optional(z.string().transform(val => +val)),
  immoAmt: z.optional(z.string().transform(val => +val)),
  maxBuyIn: z.optional(z.string().transform(val => +val)),
  results: z.optional(z.string().transform(val => val === 'true')),
});
